import React from 'react'
import { BBDTag, Horizontal, GraviButton } from '@gravitate-js/excalibrr'
import { CaretDownFilled, CaretRightFilled, DisconnectOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'

export const GroupExpander = ({ directive, isExpanded, setIsExpanded, resizeRow }) => {
  const handleClick = (event) => {
    event.stopPropagation()
    resizeRow && resizeRow()
    setIsExpanded((isExpanded) => !isExpanded)
  }
  if (directive.curve_ids.length === 0) {
    return (
      <Tooltip title='No Linked Prices'>
        <div>
          <BBDTag className='mr-4' error>
            <DisconnectOutlined className='pr-2' /> {directive.contract || directive.name}
          </BBDTag>
        </div>
      </Tooltip>
    )
  }
  return (
    <Horizontal flex={1} className='pr-3' verticalCenter>
      <Tooltip title={directive.name}>
        <GraviButton
          style={{ height: 22, padding: '0 1em' }}
          appearance='outline'
          onClick={handleClick}
          icon={isExpanded ? <CaretDownFilled /> : <CaretRightFilled />}
          theme2
          buttonText={directive.contract || directive.name}
        />
      </Tooltip>
    </Horizontal>
  )
}
